import React from 'react';
import './GameSelection.scss';

export default function ShanNineMee() {
    return <main className="app-page shan-page">
    </main>;
}
